import SubmissionCardBrandedContentAdBar from './Bar'
import SubmissionCardBrandedContentAdButton from './Button'

export { SubmissionCardBrandedContentAdButton }
export default SubmissionCardBrandedContentAdBar
